import api from './api';

export const referralService = {
  initProfile: async () => {
    const response = await api.post('/referral/init');
    return response;
  },

  getInfo: async () => {
    try {
      const response = await api.get('/referral/info');
      return response;
    } catch (e) {
      // Se nao encontrar perfil, inicializar automaticamente
      if (e.response?.status === 404) {
        await api.post('/referral/init');
        return await api.get('/referral/info');
      }
      throw e;
    }
  },

  getNetwork: async () => {
    const response = await api.get('/referral/network');
    return response;
  },

  getCommissions: async () => {
    const response = await api.get('/referral/commissions');
    return response;
  },

  requestWithdraw: async (data) => {
    const response = await api.post('/referral/withdraw', data);
    return response;
  },

  getWithdrawals: async () => {
    const response = await api.get('/referral/withdrawals');
    return response;
  },
};

export default referralService;
